import { Like } from '@depop/web-thrift-ui/Illustrations/Like';
import { useTranslations } from 'next-intl';

import { useGuestLikesToast } from '../GuestLikeToastProvider';
import { GUEST_LIKED_PRODUCTS_STORAGE_LIMIT } from '../constants';
import { getGuestLikes } from '../helpers';

import { ActivityTrackerEventType } from '@/modules/activityTracker/constants';
import { useActivityTracker } from '@/modules/activityTracker/useActivityTracker';
import { useSignup } from '@/modules/signup/hooks/useSignup';

export function useShowGuestLikesToast() {
  const t = useTranslations('common');
  const { send } = useGuestLikesToast();
  const { url } = useSignup();
  const { sendActivityTrackerEvent } = useActivityTracker();

  function handleSignupClick() {
    sendActivityTrackerEvent(ActivityTrackerEventType.CTA_ACTION, {
      type: 'guest_like_nudge_signup_cta',
      schemaVersion: '1.0',
    });
  }

  return () => {
    sendActivityTrackerEvent(ActivityTrackerEventType.GUEST_LIKE_PROMPT_VIEW, {
      type: 'like_warning',
      schemaVersion: '1.0',
      likeCount: getGuestLikes().length,
    });
    send({
      title: t('GuestLikesToast.Title', {
        count: GUEST_LIKED_PRODUCTS_STORAGE_LIMIT,
      }),
      description: t('GuestLikesToast.Description'),
      illustration: <Like size="xSmall" />,
      cta: {
        title: t('GuestLikesToast.SignUp'),
        href: url,
        onClick: handleSignupClick,
      },
    });
  };
}
